export default {
  subscription: 'cider',
  mailing_list: 27,
  info_url: 'https://cider.tavour.com',
  title: {
    in_progress: "Tavour's Curated Cider Club",
    success: "Congrats! You have joined Tavour's Curated Cider Club",
    subtext: 'Receive 6 premium adventurous ciders every month.',
  },
  cancel_anytime: 'Once we email you about a month\'s selection, you\'ll always have at least 3 days to let us know via ' +
  'email if you want to skip the beers. If needed, we\'ll cancel your subscription and confirm with a ' +
  'simple email. Real, cider loving people answer every email: please get in touch if you have any ' +
  'requests or questions.',
  review: {
    agreement: 'I agree to the <a href="https://www.tavour.com/terms-of-use" target="_blank">terms of use</a> ' +
    'and automatic billing.',
    summary: [
      "Tavour's Curated Cider Club ",
      'Each monthly box will be cost close to $65.',
      'We will always confirm the price and selection of ciders ahead of time and let you skip any box',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/cider.js